import { getUserSuccess, getUsersSuccess } from "features/userSlice";
import queryString from "query-string";
import { call, put, takeLatest } from "redux-saga/effects";
import { getRoles } from "sagas/roleSaga";
import { DELETE, GET, PATCH, POST, POST_FILE, PUT } from "services/ServiceBase";
import ServiceURL from "services/ServiceURL";
import { ActionType } from "type";
var _ = require("lodash");
export function* getUsers(data: ActionType): any {
  const { callback, body, query, skipUpdateReducer } = data.payload;
  const url = `${ServiceURL.user}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (!!res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      if (!skipUpdateReducer)
        yield put(getUsersSuccess(_.get(res, "data", {})));
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    callback.failed(error?.message ?? "");
  }
}
export function* getUser(data: ActionType): any {
  const { callback, body, query, params } = data.payload;
  const url = `${ServiceURL.user}/${params}?${query ?? ""}`;
  try {
    const res = yield call(GET, url, body);
    if (!!res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(_.get(res, "data", {}));
      yield put(getUserSuccess(_.get(res, "data", {})));
    }
  } catch (error: any) {
    callback.failed(error?.message ?? "");
  }
}
export function* createUser(data: ActionType): any {
  const { callback, body } = data.payload;
  const url = ServiceURL.user;
  try {
    const res = yield call(POST, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    callback.failed(error?.response?.data?.message ?? "");
  }
}
export function* setPassByAdmin(data: ActionType): any {
  const { callback, body } = data.payload;
  const url = ServiceURL.setpass;
  try {
    const res = yield call(POST, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
    }
  } catch (error: any) {
    callback.failed(error?.response?.data?.message ?? "");
  }
}
export function* updateUser(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.user}/${params}`;
  try {
    const res = yield call(PATCH, url, body);
    if (!!res?.response?.data?.code && !!res?.response?.data?.message) {
      callback.failed(res?.response?.data?.message);
    } else {
      callback.success(_.get(res, "data", {}));
      yield put(getUserSuccess(_.get(res, "data", {})));
    }
  } catch (error: any) {
    callback.failed(error?.response?.data?.message ?? "");
  }
}
export function* deleteUser(data: ActionType): any {
  const { callback, body, params } = data.payload;
  const url = `${ServiceURL.user}/${params}`;
  try {
    const res = yield call(DELETE, url, body);
    if (!!res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success();
    }
  } catch (error: any) {
    callback.failed(error?.message ?? "");
  }
}

export function* importListUser(dataUpload: ActionType): any {
  const { callback, data, params } = dataUpload.payload;
  const url = `${ServiceURL.user}/import`;
  try {
    const res = yield call(POST_FILE, url, data);
    if (!!res.data?.error?.message) {
      callback.failed(res.data?.error?.message);
    } else {
      callback.success(res);
    }
  } catch (error: any) {
    let err = error?.response?.data?.message || error?.message;
    callback.failed(err);
  }
}
export default function* userSaga() {
  yield takeLatest("userSlice/getUsers", getUsers);
  yield takeLatest("userSlice/getUser", getUser);
  yield takeLatest("userSlice/updateUser", updateUser);
  yield takeLatest("userSlice/createUser", createUser);
  yield takeLatest("userSlice/deleteUser", deleteUser);
  yield takeLatest("userSlice/setPassByAdmin", setPassByAdmin);
  yield takeLatest("userSlice/importListUser", importListUser);
}
